<template lang="pug">
.list-ovg-container
  //- Modal Registrar Pago Manual
  registrar-pago-manual-o-v-g(
    v-if="showPagoModal && ovgDetail"
    v-model="showPagoModal"
    :ovg="ovgDetail"
    :loading="loadingPago"
    @confirm="confirmarPagoManual"
    @cancel="showPagoModal = false"
  )

  //- Header Desktop
  .header-ovg.d-none.d-md-flex
    .title-section
      b-icon.back-arrow(icon="arrow-left-square-fill" @click="$router.go(-1)")
      h4.title Garantías Extendidas
    .actions-section
      b-button.btn-crear(variant="primary" @click="$router.push('/garantias-center/crear')")
        b-icon.mr-2(icon="plus-circle-fill")
        span Crear OVG manual
      b-input-group.search-input.ml-2
        b-form-input(
          v-model="paramsSearch"
          placeholder="Buscar por nombre, correo o N° serie..."
          @keyup.enter="buscar"
        )
        b-input-group-append
          b-button(variant="outline-secondary" @click="buscar")
            b-icon(icon="search")

  //- Breadcrumbs
  .breadcrumbs-ovg
    span.text-muted Inicio / 
    span.text-dark Garantías Extendidas

  //- Tabs de estado
  .tabs-wrapper
    .custom-tabs
      .tab-item(
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ active: tabSelected === tab.value }"
        @click="onTabChange(tab.value)"
      )
        span.tab-label {{ tab.label }}

  //- Tabla
  .table-wrapper
    b-table(
      :items="items"
      :fields="fields"
      hover
      responsive
      :busy="loadingTable"
    )
      template(#table-busy)
        .text-center.p-3
          b-spinner.mr-2(small)
          span Cargando...

      template(#cell(id)="data")
        span.id-link(@click="verDetalle(data.item.id)") {{ data.item.id }}

      template(#cell(cliente)="data")
        span {{ data.item.nombre }} {{ data.item.apellido }}

      template(#cell(estado)="data")
        b-badge(:variant="estadoVariant(data.item.estado)") {{ estadoLabel(data.item.estado) }}

      template(#cell(boleta_cliente_url)="data")
        a(v-if="data.item.boleta_cliente_url" :href="data.item.boleta_cliente_url" target="_blank")
          b-icon(icon="file-earmark-text-fill")
        span(v-else) —

      template(#cell(created_at)="data")
        span {{ formatDate(data.item.created_at) }}

      template(#cell(acciones)="data")
        .acciones-dropdown
          b-dropdown(
            size="sm"
            variant="primary"
            no-caret
            right
            boundary="window"
            :disabled="loadingModal && selectedId === data.item.id"
          )
            template(#button-content)
              b-spinner(v-if="loadingModal && selectedId === data.item.id" small)
              .d-flex.align-items-center(v-else)
                b-icon.mr-1(icon="dots-horizontal-circle" v-if="false")
                span Acciones
                b-icon.ml-1(icon="chevron-down" font-scale="0.8")
            b-dropdown-item(@click="verDetalle(data.item.id)")
              | Ver Detalle
            b-dropdown-item(
              v-if="data.item.estado === 'aprobado'"
              @click="abrirPagoManual(data.item)"
            )
              | Registrar Pago Manual
            b-dropdown-item(
              v-if="data.item.boleta_cliente_url"
              :href="data.item.boleta_cliente_url"
              target="_blank"
            )
              | Descargar Boleta Cliente
            b-dropdown-divider
            b-dropdown-item(@click="$router.push(`/garantias-center/${data.item.id}?editar=1`)")
              span.text-primary Editar
            b-dropdown-item(@click="confirmarEliminar(data.item.id)")
              span.text-danger Eliminar

    //- Paginación
    .pagination-wrapper(v-if="totalRows > pageSize")
      b-pagination(
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        align="right"
        prev-text="Ant."
        next-text="Sig."
        @change="handlePageChange"
      )

  //- Empty state
  .empty-state(v-if="!loadingTable && items.length === 0")
    .text-center.p-5
      h5 No se encontraron garantías
</template>

<script>
import { mapActions, mapState } from 'vuex'
import RegistrarPagoManualOVG from '@/components/OVG/RegistrarPagoManualOVG.vue'

export default {
  name: 'OVGListView',
  components: { RegistrarPagoManualOVG },
  data() {
    return {
      paramsSearch: '',
      loadingTable: false,
      loadingModal: false,
      loadingPago: false,
      currentPage: 1,
      pageSize: 20,
      items: [],
      totalRows: 0,
      tabSelected: 'solicitado',
      selectedId: null,
      showPagoModal: false,
      tabs: [
        { value: 'solicitado', label: 'Solicitados' },
        { value: 'aprobado', label: 'Aprobados' },
        { value: 'rechazado', label: 'Rechazados' },
        { value: 'comprado', label: 'Comprados' },
        { value: '', label: 'Todos' },
      ],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'cliente', label: 'Cliente' },
        { key: 'correo', label: 'Correo' },
        { key: 'numero_serie', label: 'N° Serie' },
        { key: 'modelo', label: 'Modelo' },
        { key: 'garantia', label: 'Plan' },
        { key: 'estado', label: 'Estado' },
        { key: 'boleta_cliente_url', label: 'Boleta' },
        { key: 'created_at', label: 'Fecha de creación' },
        { key: 'acciones', label: '', class: 'text-center' },
      ],
    }
  },
  computed: {
    ...mapState('OVGCenterStore', ['ovgDetail']),
  },
  methods: {
    ...mapActions('OVGCenterStore', [
      'listOvg',
      'getOvgDetail',
      'registrarPagoInternoOvg',
    ]),

    async fetchData() {
      this.loadingTable = true
      try {
        const res = await this.listOvg({
          page: this.currentPage,
          estado: this.tabSelected,
          q: this.paramsSearch,
        })
        this.items = res.results
        this.totalRows = res.count
      } catch (err) {
        this.$bvToast.toast('Error al cargar las garantías', {
          variant: 'danger',
        })
        this.items = []
        this.totalRows = 0
      } finally {
        this.loadingTable = false
      }
    },

    buscar() {
      this.currentPage = 1
      this.fetchData()
    },

    onTabChange(value) {
      this.tabSelected = value
      this.currentPage = 1
      this.fetchData()
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchData()
    },

    verDetalle(id) {
      this.$router.push(`/garantias-center/${id}`)
    },

    async abrirPagoManual(item) {
      this.selectedId = item.id
      this.loadingModal = true
      try {
        await this.getOvgDetail(item.id)
        this.showPagoModal = true
      } catch {
        this.$bvToast.toast('Error al cargar los datos de la garantía.', { variant: 'danger' })
      } finally {
        this.loadingModal = false
      }
    },

    async confirmarPagoManual({
      tipo_documento,
      rut_contribuyente,
      razon_social_contribuyente,
      codigo_cupon,
      giro,
      direccion_tributaria,
      comuna_tributaria,
    }) {
      this.loadingPago = true
      try {
        await this.registrarPagoInternoOvg({
          id: this.ovgDetail.id,
          tipo_documento,
          rut_contribuyente,
          razon_social_contribuyente,
          codigo_cupon,
          giro,
          direccion_tributaria,
          comuna_tributaria,
        })
        this.showPagoModal = false
        this.$bvToast.toast(
          'La garantía está activa y el documento se generó correctamente.',
          { variant: 'success', title: 'Pago registrado con éxito.' }
        )
        this.fetchData()
      } catch {
        this.$bvToast.toast(
          'El pago no ha sido registrado. Por favor, inténtalo de nuevo.',
          { variant: 'danger', title: 'No pudimos generar el documento tributario.' }
        )
      } finally {
        this.loadingPago = false
      }
    },

    confirmarEliminar(id) {
      // TODO: implementar eliminación con confirmación
      this.$bvToast.toast(`Eliminar OVG ${id} — funcionalidad pendiente.`, { variant: 'warning' })
    },

    estadoLabel(estado) {
      const labels = {
        solicitado: 'Solicitado',
        aprobado: 'Aprobado',
        rechazado: 'Rechazado',
        comprado: 'Comprado',
      }
      return labels[estado] || estado
    },

    estadoVariant(estado) {
      const variants = {
        solicitado: 'warning',
        aprobado: 'success',
        rechazado: 'danger',
        comprado: 'primary',
      }
      return variants[estado] || 'secondary'
    },

    formatDate(val) {
      if (!val) return '—'
      return new Date(val).toLocaleString('es-CL', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.list-ovg-container {
  padding: 20px;
  background-color: #f5f6fa;
  min-height: 100vh;
}

.header-ovg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
      cursor: pointer;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }

  .actions-section {
    display: flex;
    align-items: center;
    gap: 10px;

    .btn-crear {
      background-color: $samtek-yellow;
      border: none;
      color: $samtek-black;
      font-weight: 500;

      &:hover {
        background-color: darken($samtek-yellow, 5%);
      }
    }

    .search-input {
      width: 300px;
    }
  }
}

.breadcrumbs-ovg {
  margin-bottom: 25px;
  font-size: 14px;
}

.tabs-wrapper {
  background: white;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;

  .custom-tabs {
    display: flex;
    background: #f5f6fa;
    border-radius: 10px;
    padding: 5px;
    gap: 10px;

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 8px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;

      .tab-label {
        font-weight: bold;
        color: $samtek-grey;
        font-size: 14px;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }

      &.active {
        background: $samtek-yellow;

        .tab-label {
          color: $samtek-black;
        }
      }
    }
  }
}

.table-wrapper {
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  ::v-deep .b-table {
    thead th {
      background-color: #dddde1;
      color: $samtek-grey;
      border: none;
      font-weight: bold;
    }

    tbody td {
      vertical-align: middle;
      border-bottom: 1px solid #f5f6fa;
      height: 60px;
    }
  }
}

.id-link {
  color: #1d4ed8;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #1e40af;
  }
}

.acciones-dropdown {
  display: flex;
  justify-content: center;

  ::v-deep .btn {
    background-color: $samtek-yellow;
    border: none;
    color: $samtek-black;
    border-radius: 8px;
    font-weight: 500;
    font-size: 13px;
    padding: 4px 10px;

    &:hover {
      background-color: darken($samtek-yellow, 5%);
    }
  }

  ::v-deep .dropdown-menu {
    box-shadow: -8px 8px 15px 0px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 5px;
    border: none;

    .dropdown-item {
      border-radius: 4px;
      font-size: 15px;
      font-weight: 500;
      padding: 8px 10px;
      color: #525252;

      &:hover {
        background-color: #f5f6fa;
      }
    }
  }
}

.pagination-wrapper {
  margin-top: 20px;

  ::v-deep .page-item {
    &.active .page-link {
      background-color: $samtek-yellow;
      border-color: $samtek-yellow;
      color: $samtek-black;
    }

    .page-link {
      color: $samtek-black;
      border-radius: 4px;
      margin: 0 2px;
    }
  }
}
</style>
